import { Fetcher } from '../../Fetcher';

import type { PrivateOptionsParams, PrivateOptionsResponse } from './types';

export const fetchPrivateChatOptions = ({
  baseUrl,
  tableId,
}: PrivateOptionsParams): Promise<PrivateOptionsResponse> => {
  return Fetcher.fetch<PrivateOptionsResponse>(`${baseUrl}/api/privatePlayerRequest/${tableId}`);
};
